import type { State } from '../api.js';
import { t } from '../i18n.js';

interface Props {
  state: State;
  onPresenceTap: () => void;
}

export function TileRow({ state, onPresenceTap }: Props) {
  const humidity = state.zone?.humidity;
  const outside = state.weather?.outside_temp;
  const presence = state.presence;
  const atHome = presence?.at_home === 1;
  const presenceLabel = presence == null ? '—' : atHome ? t('tile.presence_home') : t('tile.presence_away');
  const presenceIcon = presence == null ? '·' : atHome ? '🏠' : '✈';

  return (
    <div className="tiles">
      <div className="tile">
        <div className="tile-icon">💧</div>
        <div className="tile-label">{t('tile.humidity')}</div>
        <div className="tile-val">{humidity != null ? `${humidity.toFixed(0)}%` : '—'}</div>
      </div>
      <div className="tile">
        <div className="tile-icon">☁</div>
        <div className="tile-label">{t('tile.outside')}</div>
        <div className="tile-val">{outside != null ? `${outside.toFixed(1)}°` : '—'}</div>
      </div>
      <button
        className="tile is-tappable"
        onClick={onPresenceTap}
        aria-label={t('presence.title')}
      >
        <div className="tile-icon">{presenceIcon}</div>
        <div className="tile-label">{t('tile.home')}</div>
        <div className="tile-val">{presenceLabel}</div>
        <div className="tile-hint">{t('tile.tap_to_change')}</div>
      </button>
    </div>
  );
}
